import React, {useState, useCallback} from "react"

import OptionsSelector from "./OptionsSelector.jsx";

export default ({productHandle, variants, onSelect}) => {

  const [selectOptions, setSelectOptions] = useState([]);

  const setValue = useCallback((index) => (value) => {
    const newOptions = [...selectOptions];
    newOptions[index] = value;

    console.log("setValue", newOptions, index, value);

    if(typeof onSelect == 'function'){
      const filteredVariants = variants.filter((variant) => {
        for(let i = 0; i < newOptions.length; i++){
          const option = newOptions[i];
          if(option && option != variant.options[i].value){
            return false;
          }
        }
        return true;
      });

      if(filteredVariants.length == 1){
        onSelect(filteredVariants[0]);
      }else{
        setSelectOptions(newOptions);
      }
    }else{
      setSelectOptions(newOptions);
    }
  }, [variants, selectOptions]);

  const optionsArray = [];
  variants.forEach(({options}) => {
    options.forEach(({name, value}, index) => {
      optionsArray[index] = optionsArray[index] || { values: [], title: name }
      const optionExists = optionsArray[index].values.find((option) => option.value == value);
      if(optionExists){
        return;
      }
      optionsArray[index].values.push({
        value: value,
        selected: value == selectOptions[index]
      });
    })
  });

  return <div className="drawer-customizer__product-options">
    {optionsArray.map(({title, values}, index) => <OptionsSelector key={`optionSelection-${index}`} productHandle={productHandle} title={title} values={values} setValue={setValue} index={index} /> )}
  </div>
}
